// extracted by mini-css-extract-plugin
module.exports = {"description":"work_description__N6YDr"};